export const smallDesktop = '(max-width: 1279px)';
export const tablet = '(max-width: 768px)';
